import React from 'react';

const MessageCircle = () => (
  <path d="M7.0225 26.0598a.8.8 0 0 1-1.0227-1.0084l2.167-6.498C7.4197 17.028 7 15.313 7 13.5 7 7.1487 12.1487 2 18.5 2S30 7.1487 30 13.5 24.8513 25 18.5 25c-1.821 0-3.5433-.4233-5.0736-1.1768l-6.404 2.2366zm1.6477-2.694l4.888-1.707.7517.3701C15.6015 22.665 17.0248 23 18.5 23c5.2467 0 9.5-4.2533 9.5-9.5S23.7467 4 18.5 4 9 8.2533 9 13.5c0 1.4688.3322 2.8862.9629 4.1734l.3604.7356-1.653 4.9568z" />
);

export default MessageCircle;
